import { Component, Input, ViewChild } from '@angular/core';
import { MaterialModule } from '../../../shared/material.module';
import { OpbDetailsTabComponent } from './tabs/opb-details-tab/opb-details-tab.component';
import { OpbCompanyDto } from '../../../models/api/opbCompanyDto';
import { HasUnsavedChanges } from '../../../guards/unsaved-changes.guard';

@Component({
  selector: 'app-opb-company-form',
  imports: [
    MaterialModule,
    OpbDetailsTabComponent
  ],
  templateUrl: './opb-company-form.component.html',
  styleUrl: './opb-company-form.component.scss'
})
export class OpbCompanyFormComponent implements HasUnsavedChanges {
  @Input() isEditMode = false;
  @Input() companyData: OpbCompanyDto | null = null;

  @ViewChild(OpbDetailsTabComponent) detailsTab?: OpbDetailsTabComponent;

  hasUnsavedChanges(): boolean {
    return this.detailsTab?.hasUnsavedChanges() ?? false;
  }
}
